// extracted by mini-css-extract-plugin
export default {"recentlyViewed":"_7f0b4944","container":"_3f52b931"};